import type { Implementation } from "../types/Implementation"
import type { MessageRouter } from "../types/MessageRouter"
import type { ReceiverInput } from "../types/ReceiverInput"
import type { ReceiverOutput } from "../types/ReceiverOutput"

export function RequestHandler<T, R>(
  func: Implementation<T, R>,
  forward?: MessageRouter<T, R>
): MessageRouter<T, R> {
  const router = (request: ReceiverInput<T>): ReceiverOutput<R> =>
    func(request, forward ?? router)
  return router
}
